import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PortalLifecycleStatus } from "../../../../autogen/bff-api";

// Labels are looked up dynamically by status, so langen can't see them statically:
// t("Open for bids") t("Deadline passed") t("Under evaluation") t("Awarded") t("Cancelled")
const META: Record<PortalLifecycleStatus, { color: string; key: string }> = {
  [PortalLifecycleStatus.Open]: { color: "green", key: "Open for bids" },
  [PortalLifecycleStatus.DeadlinePassed]: { color: "orange", key: "Deadline passed" },
  [PortalLifecycleStatus.UnderEvaluation]: { color: "blue", key: "Under evaluation" },
  [PortalLifecycleStatus.Awarded]: { color: "purple", key: "Awarded" },
  [PortalLifecycleStatus.Cancelled]: { color: "gray", key: "Cancelled" },
};

export const PortalLifecycleTag = ({
  status,
  size = "sm",
}: {
  status: PortalLifecycleStatus;
  size?: "sm" | "md" | "lg";
}) => {
  const { t } = useTranslation();
  const meta = META[status];
  return (
    <Tag variant="outline" colorScheme={meta.color} size={size}>
      {t(meta.key)}
    </Tag>
  );
};
